import Swiper from 'swiper/bundle';

//------------------------------------------------//
//-------------- PRODUCT IMAGE SWIPER ------------//
//------------------------------------------------//

const product_images = document.querySelectorAll('[id^="product_info_and_image_gallery_"]');

product_images.forEach(el => {

  let product_thumbs = new Swiper ('#' + el.id + ' .product-image-thumbs', {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    watchOverflow: false,
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
    },
    navigation: {
      nextEl: '#' + el.id + ' .product-image-thumbs .swiper-button-next',
    },
  });

  let product_image_main = new Swiper ('#' + el.id + ' .product-image-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 10,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: product_thumbs,
    },
    navigation: {
      nextEl: '#' + el.id + ' .product-image-thumbs .swiper-button-next',
    },
  });
});

//------------------------------------------------//
//------------- Video Playback on Slides ---------//
//------------------------------------------------//

const playableImages = document.querySelectorAll(".placeholder-image.playable");
playableImages.forEach(img => {
  img.addEventListener('click', function() {
    this.style.display = 'none';
    const siblings = this.parentElement.querySelectorAll(".placeholder-image");
    siblings.forEach(sib => sib.style.display = 'none');
    const video = document.querySelector("#video");
    if (video) {
      video.play();
      console.log("video played");
    }
  });
});


